import {useMemo} from 'react';
import type {DataLoadStatus, Media} from 'api/types';
import {getMediaByEans, useLazyGetResourceWithRefresh} from 'api';
import {useGetTokens} from 'services/auth';

export const useLazyManifestationMediaData = (
  eans: string[],
  doLoad: boolean,
  mock?: boolean,
): {
  media: DataLoadStatus<Media[]>;
  refreshMedia: () => void;
} => {
  const token = useGetTokens();

  const {result: media, refresh: refreshMedia} = useLazyGetResourceWithRefresh(
    doLoad,
    () => getMediaByEans(eans, token, mock),
  );

  return useMemo(
    () => ({
      media,
      refreshMedia,
    }),
    [media, refreshMedia],
  );
};
